/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { AudienceSentimentDriversWidget as AudienceSentimentDriversWidgetType } from '../../../../schemas/AudienceSentimentDriversWidgetSchema'
import TableDisplay from './TableDisplay'
import WordCloudDisplay from './WordCloudDisplay'
import DisplayOption from '../../../../enums/DisplayOption'

const AudienceSentimentDriversWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceSentimentDriversWidgetType>(widgetId)

  const { displayOption } = widgetSetting
  if (!displayOption || displayOption === DisplayOption.WORDCLOUD) {
    return <WordCloudDisplay widgetId={widgetId} />
  }

  if (displayOption === DisplayOption.TABLE) {
    return <TableDisplay widgetId={widgetId} />
  }

  throw new Error(`Unsupported display option: ${displayOption}`)
}
export default AudienceSentimentDriversWidget
